export enum CompanyType {
  None = 'None',
  Partner = 'Partner',
  InternalTest = 'Internal Test',
  Trial = 'Trial',
  PayingCustomer = 'Paying Customer',
  Other = 'Other',
}
